export default {
  buttonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  tableIcon: {
    fontSize: '16px !important',
    color: 'rgba(0, 0, 0, 0.65)',
  },
  createButton: {
    marginBottom: 10,
  },
  savedJobChartsButton: {
    marginTop: 32,
  },
  marginBetweenSelect: {
    marginRight: 15,
  },
  paddingToContainerContent: {
    paddingLeft: 5,
    paddingRight: 5,
  },
  hide: {
    display: 'none',
  },
  tableStyle: {
    padding: '5px',
    overflow: 'auto',
  },
  padding20: {
    padding: 20,
  },
  inputTable: {
    width: '100%',
    // width: 'max-content',
    '& div.ant-form-item': {
      margin: '0 !important',
    },
    '& div.ant-select-selector': {
      padding: '0 0 0 2px !important',
    },
    '& span.ant-select-selection-item': {
      paddingRight: '0 !important',
    },
    '& span.ant-select-arrow': {
      display: 'none !important',
    },
    '& span.ant-picker-suffix': {
      // display: 'none !important',
    },
    '& span.ant-picker-clear': {
      // display: 'none !important',
    },
    '& input.ant-input': {
      padding: '4px 2px !important',
    },
    '& div.ant-input-number-handler-wrap': {
      display: 'none !important',
    },
    '& div.ant-picker': {
      padding: '4px 2px !important',
    },
    '& input.ant-input-number-input': {
      padding: '4px 2px !important',
    },
    tableLayout: 'fixed',
    textAlign: 'left',
    borderCollapse: 'separate;',
    borderRadius: '2px 2px 0 0',
    borderSpacing: 0,
  },
  inputThead: {
    overflowWrap: 'break-word',
    textAlign: 'center',
    backgroundColor: '#fafafa',
  },
  inputTh: {
    border: '1px solid #f0f0f0',
    fontWeight: 500,
    backgroundColor: '#c5c5c5',
    color: 'rgb(0, 0, 0)',
    padding: '2px',
    borderCollapse: 'collapse',
  },
  inputTd: {
    border: '1px solid #f0f0f0',
  },
  inputTdWithPadding: {
    border: '1px solid #f0f0f0',
    padding: '5px',
  },
  previewSpan: {
    color: '#0b2933 !important',
    fontWeight: 500,
  },
  previewMainHeading: {
    color: '#0b2933 !important',
    fontWeight: 600,
    textAlign: 'center',
  },
  previewSubHeading: {
    color: '#0b2933 !important',
    // fontWeight: 500,
    paddingLeft: '5px',
  },
  flexCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  paddingSmall: {
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 5,
  },
  jobchartImage: {
    maxHeight: 100,
    maxWidth: 100,
    width: 'auto',
    height: 'auto',
  },
  defaultLink: {
    color: 'black',
    textDecoration: 'none',
  },
};
